import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import classes from './FooterLayout.module.scss';
import FooterApp from "../../components/layout/Footers";
import FooterLegal from "../../components/layout/Footers/FooterLegal";
import WhatsAppButton from '../../components/UI/WhatsAppButton/WhatsAppButton';
import {withRouter} from 'react-router-dom'
import {Context} from "../../context/Wrapper";

const FooterLayout = (props) => {
    const context = useContext(Context)

    const [state, setState] = useState({
        home_product_categories: [],
        public_footers: [],
        setting: [],
        done: false,
    });

    useEffect(() => {
        //===========================================
        //useEffect 1
        //===========================================
        const ourRequest = axios.CancelToken.source();
        const fetchData = async () => {
            const header = {headers: {'language': context.locale}};
            const get_home_product_categories = await axios.get('product_categories', header, {cancelToken: ourRequest.token});
            const get_public_settings = await axios.get('setting', header, {cancelToken: ourRequest.token});
            setState({
                ...state,
                home_product_categories: get_home_product_categories.data.product_categories,
                setting: get_public_settings.data,
                done: true
            });
        }
        try {
            fetchData()
        } catch (e) {

        }

        return () => {
            ourRequest.cancel();
        }
        //eslint-disable-next-line
    }, [context.locale]);

    const goRefresh = (category_slug, category_id, sub_category_slug, sub_category_id, category_title) => {
        props.history.replace('/product-categories/' + category_slug);
        // setState({currentPage: 1, done: true}) //this going to check later
        localStorage.setItem("selected_category_id", category_id);
        localStorage.setItem("selected_category", category_slug);
        localStorage.setItem("selected_sub_category", sub_category_slug);
        localStorage.setItem("selected_sub_category_id", sub_category_id);
        localStorage.setItem('ct_param_product_category', category_title);
    }

    return (
        <>
            <div className={classes.Main_footer}>
                <div className={classes.Footer_hr}/>
                <section className={['jbfs-section footer-app-section-sm', classes.FooterApp_section].join(' ')}>
                    <div className={["jbfs-wrapper footer-app-wrapper-sm", classes.FooterLayout_wrapper].join(' ')}>
                        <FooterApp prodCategory={state.home_product_categories}
                                   settings={state.setting}
                                   done={state.done}
                                   goRefresh={goRefresh}
                        />
                    </div>
                </section>
                <section className={['jbfs-section footer-legal-section-sm', classes.FooterLegal_section].join(' ')}>
                    <div className={["jbfs-wrapper footer-legal-wrapper-sm", classes.FooterLayout_wrapper].join(' ')}>
                        <FooterLegal data={state.public_footers}/>
                    </div>
                </section>
                {/* floating whatsapp button */}
                <WhatsAppButton phone={state.setting && state.setting.whatsapp ? state.setting.whatsapp : '6281188880811'} />
            </div>
        </>
    )
}

export default withRouter(FooterLayout)